const checkoutDefaultState = {
  currentCheckoutStep: "shipping",
  // customerDetailsSubmitted: false,
  customerDetails: {
    firstName: "",
    lastName: "",
    address1: "",
    address2: "",
    town: "",
    county: "",
    postCode: "",
    phoneNumber: "",
    emailAddress: "",
  },
}

export default (state = checkoutDefaultState, action) => {
  switch (action.type) {
    case "ADD_CUSTOMER_DETAILS":
      return {
        ...state,
        ...action.currentCheckoutStep,
        customerDetails: {
          ...state.customerDetails,
          ...action.customerDetails,
        },
      }
    case "SWITCH_CHECKOUT_STEP":
      return {
        ...state,
        ...action.currentCheckoutStep,
      }
    default:
      return state
  }
}
